/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrevRiskScore
 */
export interface PrevRiskScore {
}

/**
 * Check if a given object implements the PrevRiskScore interface.
 */
export function instanceOfPrevRiskScore(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrevRiskScoreFromJSON(json: any): PrevRiskScore {
    return PrevRiskScoreFromJSONTyped(json, false);
}

export function PrevRiskScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrevRiskScore {
    return json;
}

export function PrevRiskScoreToJSON(value?: PrevRiskScore | null): any {
    return value;
}

